import styled from 'styled-components';

export const Container = styled.button`
  position: relative;
  cursor: pointer;

  & > svg {
    color: white;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  &:hover {
    & > div {
      background: rgb(63, 94, 155);
      color: transparent;
    }

    & > svg {
      display: block;
    }
  }
`;
